// extracted by css-extract-rspack-plugin
export default {"ApplicationOverview":"sputnik__ApplicationOverview__tyFej","applicationOverview":"sputnik__ApplicationOverview__tyFej"};